import { makeAutoObservable } from 'mobx'

export type TabType = 'home' | 'chat' | 'review'

class ChatStore {
  activeTab: TabType = 'chat'
  rolePlayEnabled: boolean = false
  reviewEnabled: boolean = false
  rolePlayContext: {
    context?: any
    goal?: string
    methodology?: string
    conversation?: Array<{ role: string; content: string }>
  } = {}

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  setActiveTab(tab: TabType) {
    this.activeTab = tab
  }

  setRolePlayEnabled(enabled: boolean) {
    this.rolePlayEnabled = enabled
  }

  setReviewEnabled(enabled: boolean) {
    this.reviewEnabled = enabled
  }

  setRolePlayContext(data: { context?: any; goal?: string; methodology?: string; conversation?: Array<{ role: string; content: string }> }) {
    this.rolePlayContext = data
  }

  finishRolePlayAndStartReview(data: { context?: any; goal?: string; methodology?: string; conversation?: Array<{ role: string; content: string }> }) {
    this.setRolePlayContext(data)
    this.setReviewEnabled(true)
    this.setActiveTab('review')
  }

  getSystemPrompt(): string[] {
    return []
  }
}

export const chatStore = new ChatStore()
